export class StoreDebugger {

    constructor(store, options = {}) {
        this.originalStore = store;

        this.options = {
            enabled: options.enabled ?? true,
            logChanges: options.logChanges ?? true,

            level: options.level ?? {
                enabled: false,
                properties: null
            },

            database: options.database ?? {
                enabled: false,
                properties: null
            },

            input: options.input ?? {
                enabled: false,
                properties: null
            },

            config: options.config ?? {
                enabled: false,
                properties: null
            },

            entities: options.entities ?? {
                enabled: false,
                properties: null
            }
        };

        this.arrayOperation = false;

        this.store = this.createStoreProxy(store);
    }


    getStore() {
        return this.store;
    }


    createStoreProxy(store) {

        const debuggerInstance = this;

        return new Proxy(store, {

            get(target, property, receiver) {

                const value = Reflect.get(target, property, receiver);

                // Csak a Store általunk megadott fő részeit figyeljük
                if (
                    property === "level" ||
                    property === "database" ||
                    property === "input" ||
                    property === "config" ||
                    property === "entities"
                ) {
                    return debuggerInstance.createSectionProxy(
                        value,
                        property
                    );
                }

                return value;
            }
        });
    }


    createSectionProxy(section, sectionName) {

        if (!section || typeof section !== "object") {
            return section;
        }

        const debuggerInstance = this;
        const config = this.options[sectionName];

        if (!config || !config.enabled) {
            return section;
        }

        return new Proxy(section, {

            get(target, property, receiver) {

                const value = Reflect.get(target, property, receiver);

                if (!debuggerInstance.shouldWatch(
                    sectionName,
                    property
                )) {
                    return value;
                }

                // Tömb esetén csak a módosító műveletet figyeljük
                if (
                    Array.isArray(value) &&
                    debuggerInstance.options.logChanges
                ) {
                    return debuggerInstance.createArrayProxy(
                        value,
                        `${sectionName}.${String(property)}`
                    );
                }

                return value;
            },


            set(target, property, value, receiver) {

                if (
                    debuggerInstance.shouldWatch(
                        sectionName,
                        property
                    )
                ) {

                    const oldValue = target[property];

                    if (oldValue !== value) {

                        debuggerInstance.logChange(
                            `${sectionName}.${String(property)}`,
                            oldValue,
                            value
                        );
                    }
                }

                return Reflect.set(
                    target,
                    property,
                    value,
                    receiver
                );
            }
        });
    }


    createArrayProxy(array, path) {

        const debuggerInstance = this;

        return new Proxy(array, {

            get(target, property, receiver) {

                // Csak a tömb módosító műveleteit kezeljük
                if (
                    property === "push" ||
                    property === "pop" ||
                    property === "shift" ||
                    property === "unshift" ||
                    property === "splice"
                ) {

                    return function (...args) {

                        let result;

                        switch (property) {

                            case "push":
                                debuggerInstance.logArrayChange(
                                    path,
                                    "PUSH",
                                    args
                                );
                                break;

                            case "pop":
                                debuggerInstance.logArrayChange(
                                    path,
                                    "POP"
                                );
                                break;

                            case "shift":
                                debuggerInstance.logArrayChange(
                                    path,
                                    "SHIFT"
                                );
                                break;

                            case "unshift":
                                debuggerInstance.logArrayChange(
                                    path,
                                    "UNSHIFT",
                                    args
                                );
                                break;

                            case "splice":
                                debuggerInstance.logArrayChange(
                                    path,
                                    "SPLICE",
                                    args
                                );
                                break;
                        }

                        // Az eredeti tömbön hajtjuk végre
                        result = Array.prototype[property].apply(
                            target,
                            args
                        );

                        return result;
                    };
                }

                // Minden más tömbművelet változtatás nélkül
                return Reflect.get(
                    target,
                    property,
                    receiver
                );
            },


            set(target, property, value, receiver) {

                // Tömb index / length változásait NEM logoljuk.
                // A push/splice stb. már külön logolva lett.
                return Reflect.set(
                    target,
                    property,
                    value,
                    receiver
                );
            }
        });
    }


    shouldWatch(section, property) {

        const config = this.options[section];

        if (!config || !config.enabled) {
            return false;
        }

        if (!config.properties) {
            return true;
        }

        return config.properties.includes(
            String(property)
        );
    }


    logChange(path, oldValue, newValue) {
/*
        console.groupCollapsed(
            `%c[STORE CHANGE] ${path}`,
            "font-weight:bold"
        );

        console.log("OLD:", oldValue);
        console.log("NEW:", newValue);

        console.trace();

        console.groupEnd();
*/
    }


    logArrayChange(path, operation, items = []) {

        console.groupCollapsed(
            `%c[STORE ARRAY] ${path} → ${operation}`,
            "font-weight:bold"
        );

        if (items.length > 0) {
            console.log("ITEMS:", items);
        }

        console.trace();

        console.groupEnd();
    }


    enable() {
        this.options.enabled = true;
    }


    disable() {
        this.options.enabled = false;
    }


    toggle() {
        this.options.enabled = !this.options.enabled;
    }
}